import formData from "./formData";

export default {
  formData: formData,
};
